import {TOWN_REPORTS} from '../data/townReportNavigation';
// src/features/townBudget/components/SummaryOfProjections.jsx

import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { HeaderToggleButton } from "../../../shared/ui/overlay/HeaderToggleButton";

import { CommonTable } from "../../../shared/ui/table/CommonTable.jsx";
import WarningMessage from "../../../shared/ui/feedback/WarningMessage.jsx";
import { buildProjectionColumns } from "../../../budget/model/columns/columnBuilders.js";
import { fetchProjectionTables } from "../data/fetchProjectionTables.js";

function SummaryOfProjections() {
  const { selectedYear = "" } = useOutletContext();

  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(true);
  const [columns, setColumns] = useState([]);

  const [operatingData, setOperatingData] = useState([]);
  const [fundsData, setFundsData] = useState([]);
  const [ufbData, setUfbData] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const loadData = async () => {
      setLoading(true);
      setColumns([]);
      setOperatingData([]);
      setFundsData([]);
      setUfbData([]);

      try {
        const {
          currentYear,
          operatingData,
          fundsData,
          ufbData,
        } = await fetchProjectionTables(selectedYear);

        if (cancelled) return;

        if (!currentYear) {
          setLoading(false);
          return;
        }

        const { columns: tableCols } = buildProjectionColumns(currentYear);

        setColumns(tableCols);
        setOperatingData(operatingData);
        setFundsData(fundsData);
        setUfbData(ufbData);
      } catch (err) {
        console.error("Error loading fund balance summary:", err);
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadData();

    return () => {
      cancelled = true;
    };
  }, [selectedYear]);

  if (loading) {
    return <div className="p-4">Loading fund balance summary...</div>;
  }

  if (!operatingData.length && !fundsData.length && !ufbData.length) {
    return (
      <WarningMessage message="No fund balance projections available for the selected year." />
    );
  }

  return (
    <div className="bg-base-100 shadow-md rounded-lg p-2 mt-6 border border-gray-300">
      <HeaderToggleButton reportNavigation title={TOWN_REPORTS[3].title} controlsId="town-fund-balance"
        isOpen={!collapsed} onToggle={() => setCollapsed(prev => !prev)} />

      {!collapsed && (
        <div id="town-fund-balance" className="bg-white p-4 space-y-6">
          <CommonTable
            columns={columns}
            data={operatingData}
            title="Operating Results Summary"
            headerColor="bg-[#d5e7f7]"
            showAggregateTotal={false}
          />
          <CommonTable
            columns={columns}
            data={fundsData}
            title="Fund Balance"
            headerColor="bg-[#d5e7f7]"
            showAggregateTotal={false}
          />
          <CommonTable
            columns={columns}
            data={ufbData}
            title="UFB Benchmark Comparison"
            headerColor="bg-[#f3f4f6]"
            showAggregateTotal={false}
          />
        </div>
      )}
    </div>
  );
}

export default SummaryOfProjections;
